export default __webpack_public_path__ + "static/media/Group 44.6dc07940.png";